import { AbstractLiteral } from './AbstractLiteral.js';
import { registry } from '../../registry.js';

export class BoolLiteral extends AbstractLiteral {

    /* SYNTAX RULES */

    static get syntaxRules() { return { type: 'bool_literal', as: '.' }; }

    /* TYPESYS API */

    dataType() { return registry.DataType.fromJSON({ value: 'BOOLEAN' }); }
}